import { render, staticRenderFns } from "@/templates/serviceDelivery/sdUploaded.html?vue&type=template&id=3c47d483&"
import script from "./SDUploaded.vue?vue&type=script&lang=js&"
export * from "./SDUploaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports